import React, { useEffect } from "react";
import Nav from "../components/main/nav";
import Header from "../components/main/header";
import WorkSection from "../components/main/WorkSection";
import Footer from "../components/main/Footer";
import { useDispatch } from "react-redux";
import { getEmpleosNoAuth } from "../redux/empleo";

const Index = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getEmpleosNoAuth("", ""));
  }, [dispatch]);

  return (
    <>
      <Nav />
      <Header />
      <WorkSection />
      <Footer />
    </>
  );
};

export default Index;
